import axiosInstance from '../helpers/axiosInstance';

export const fetchItineraryUsers = (tripId) =>
  axiosInstance.get(`/bucket-list/${tripId}/itinerary-users`);

export const fetchPackingUsers = (tripId) =>
  axiosInstance.get(`/packing_lists/${tripId}/packing-users`);

export const fetchBudgetUsers = (tripId) =>
  axiosInstance.get(`/budget_planner/${tripId}/budget-users`); 